import React from 'react'
import { useStyles } from './styles'
import { Menu as MenuIcon } from '@material-ui/icons'
import { Redirect } from 'src/components/Redirect'
import ROUTES from 'src/constants/routes'
import { useAuth } from 'src/contexts/auth'
import { useGetAllFarms, useGetFarmList } from 'src/hooks/api/farm'

interface MobileHeaderProps {
  onMenuToggle: () => void
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle }) => {
  const classes = useStyles()
  const { name, user, userFarm } = useAuth()
  const { data: apiFarms } = useGetFarmList()
  const farms = apiFarms ?? user?.listPropriedades ?? []

  const currentFarmName = farms.find((p) => p.idFazenda === userFarm)?.descricao

  return (
    <header className={classes.mobileHeader}>
      <button className={classes.menuButton} onClick={onMenuToggle} aria-label='Toggle menu'>
        <MenuIcon />
      </button>

      <div className={classes.logoContainer}>
        <Redirect to={ROUTES.DASHBOARD} className={classes.logo}>
          CONGADO
        </Redirect>
        {currentFarmName && <span className={classes.farmName}>{currentFarmName}</span>}
      </div>

      <Redirect to={ROUTES.PROFILE} className={classes.userAvatar}>
        {name?.[0] || 'U'}
      </Redirect>
    </header>
  )
}
